const helpCenter = [
  {
    id: 1,
    title: 'Getting started',
    key: 'gettingStarted',
    tabPath: 'getting-started',
    subTabs: [
      {
        id: 2,
        title: 'Get Started Within A Few Minutes',
        hasTabs: true,
        subTabPath: 'Get-Started-Within-A-Few-Minutes',
        videos: [
          {
            id: 37,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/ajt73zy7sg',
          },
          {
            id: 38,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/mftbajn65v',
          },
        ],

      },
      {
        id: 3,
        title: 'Customisable Layouts',
        hasTabs: true,
        subTabPath: 'Customisable-Layouts',
        videos: [
          {
            id: 39,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/ld0y8ltub3',
          },
          {
            id: 40,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/ktxo5yh7gp',
          },
        ],
      },
      {
        id: 4,
        title: 'How can we help people NEW to investing?',
        hasTabs: false,
        subTabPath: 'How-can-we-help-people-NEW-to-investing',
        videos: [
          {
            id: 66,
            link: 'https://cityfalcon.wistia.com/medias/6cuqw5rruw',
          },
        ],
      },
      {
        id: 59,
        title: 'Powerful Searches',
        hasTabs: false,
        subTabPath: 'Powerfull-Searches',
        videos: [
          {
            id: 67,
            link: 'https://cityfalcon.wistia.com/medias/mgs3azy07o',
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: 'Key Features',
    key: 'keyFeatures',
    tabPath: 'key-features',
    subTabs: [
      {
        id: 6,
        title: 'Content Summarisation',
        hasTabs: true,
        subTabPath: 'Content-Summarisation',
        videos: [
          {
            id: 43,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/k5usrkqi3k',
          },
          {
            id: 44,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/2eznzz1ra6',
          },
        ],
      },
      {
        id: 7,
        title: 'Price Movements With CityFalcon Charts',
        hasTabs: true,
        subTabPath: 'Price-Movements-With-CityFalcon-Charts',
        videos: [
          {
            id: 45,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/ss2alfe5pj',
          },
          {
            id: 46,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/bg126ct1i0',
          },
        ],
      },
      {
        id: 8,
        title: 'Markets and Sentiment Analysis',
        hasTabs: true,
        subTabPath: 'Markets-and-Sentiment-Analysis',
        videos: [
          {
            id: 47,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/362922bfs9',
          },
          {
            id: 48,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/xxio1ni47b',
          },
        ],
      },
      {
        id: 9,
        title: 'Public and Private Company Filings',
        hasTabs: true,
        subTabPath: 'Public-and-Private-Company-Filings',
        videos: [
          {
            id: 49,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/zj9uvpl28w',
          },
          {
            id: 50,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/2p8zwc1y1e',
          },
        ],
      },
      {
        id: 10,
        title: 'What are Trending Assets',
        hasTabs: true,
        subTabPath: 'What-are-Trending-Assets',
        videos: [
          {
            id: 51,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/be7nogrmi6',
          },
          {
            id: 52,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/u1x1niau9u',
          },
        ],
      },
      {
        id: 11,
        title: 'What is CityFALCON Score?',
        hasTabs: false,
        subTabPath: 'What-is-CityFALCON-Score',
        videos: [
          {
            id: 68,
            link: 'https://cityfalcon.wistia.com/medias/wczq8f0kof',
          },
        ],
      },
      {
        id: 12,
        title: 'Natural Language Processing (NLU)',
        hasTabs: false,
        subTabPath: 'Natural-Language-Processing-(NLU)',
        videos: [
          {
            id: 69,
            link: 'https://cityfalcon.wistia.com/medias/3s8nuthz6f',
          },
        ],
      },
      {
        id: 13,
        title: 'Access Paywall-free Content From 1000+ Publications',
        hasTabs: true,
        subTabPath: 'Access-Paywall-free-Content-From-1000-Publications',
        videos: [
          {
            id: 53,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/nq8g9ra0th',
          },
          {
            id: 54,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/el5pzya155',
          },
        ],
      },
      {
        id: 60,
        title: 'Broad Source Coverage (10k+)',
        hasTabs: false,
        subTabPath: 'Broad-Source-Coverage-(10k+)',
        videos: [
          {
            id: 70,
            link: 'https://cityfalcon.wistia.com/medias/d53wjjkl1e',
          },
        ],
      },
      {
        id: 61,
        title: 'Financial Twitter and Social Media',
        hasTabs: false,
        subTabPath: 'Financial-Twitter-and-Social-Media',
        videos: [
          {
            id: 71,
            link: 'https://cityfalcon.wistia.com/medias/ap7t5ohqzm',
          },
        ],
      },
      {
        id: 62,
        title: 'Investor Relations Content',
        hasTabs: false,
        subTabPath: 'Investor-Relations-Content',
        videos: [
          {
            id: 72,
            link: 'https://cityfalcon.wistia.com/medias/etz5wqtf0a',
          },
        ],
      },
    ],
  },
  {
    id: 22,
    title: 'API & Data Services',
    key: 'apiAndDataServices',
    tabPath: 'api-and-data-services',
    subTabs: [
      {
        id: 23,
        title: 'API',
        hasTabs: false,
        subTabPath: 'API',
        videos: [
          {
            id: 73,
            link: 'https://cityfalcon.wistia.com/medias/wijksrco2x',
          },
        ],
      },
    ],
  },
  {
    id: 24,
    title: 'Web & Mobile Plans',
    key: 'apiAndDataServices',
    tabPath: 'web-mobile-plans',
    subTabs: [
      {
        id: 25,
        title: 'Basic',
        hasTabs: false,
        subTabPath: 'Basic',
        videos: [
          {
            id: 74,
            link: 'https://cityfalcon.wistia.com/medias/cnayh4e5gt',
          },
        ],
      },
      {
        id: 26,
        title: 'Silver',
        hasTabs: false,
        subTabPath: 'Silver',
        videos: [
          {
            id: 75,
            link: 'https://cityfalcon.wistia.com/medias/463yulnng2',
          },
        ],
      },
      {
        id: 27,
        title: 'Gold',
        hasTabs: false,
        subTabPath: 'Gold',
        videos: [
          {
            id: 76,
            link: 'https://cityfalcon.wistia.com/medias/d83ycy15rv',
          },
        ],
      },
      {
        id: 28,
        title: 'Manage Your Subscriptions to Access Best Content',
        hasTabs: true,
        subTabPath: 'Manage-Your-Subscriptions-to-Access-Best-Content',
        videos: [
          {
            id: 55,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/u6u2dn05wb',
          },
          {
            id: 56,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/jr1gosllis',
          },
        ],
      },
    ],
  },
  {
    id: 29,
    title: 'Asset Classes',
    key: 'assetClasses',
    tabPath: 'asset-classes',
    subTabs: [
      {
        id: 30,
        title: 'Stocks',
        hasTabs: false,
        subTabPath: 'Stocks',
        videos: [
          {
            id: 77,
            link: 'https://cityfalcon.wistia.com/medias/k55d2nkan7',
          },
        ],
      },
      {
        id: 31,
        title: 'Cryptos',
        hasTabs: false,
        subTabPath: 'Cryptos',
        videos: [
          {
            id: 78,
            link: 'https://cityfalcon.wistia.com/medias/nvrijpors2',
          },
        ],
      },
      {
        id: 32,
        title: 'Ratings & Research Firms',
        hasTabs: true,
        subTabPath: 'Ratings-Research-Firms',
        videos: [
          {
            id: 57,
            activeTab: 'desktop',
            link: 'https://cityfalcon.wistia.com/medias/t5qc3w8zuw',
          },
          {
            id: 58,
            activeTab: 'mobile',
            link: 'https://cityfalcon.wistia.com/medias/o29qf5n8sd',
          },
        ],
      },
    ],
  },
  {
    id: 33,
    title: 'Voice',
    key: 'voice',
    tabPath: 'voice',
    subTabs: [
      {
        id: 34,
        title: 'Personalised financial news at the command of your voice!',
        hasTabs: false,
        subTabPath: 'Personalised-financial-news-at-the-command-of-your-voice',
        videos: [
          {
            id: 79,
            link: 'https://cityfalcon.wistia.com/medias/1cyold2f7s',
          },
        ],
      },
      {
        id: 35,
        title: 'CityFALCON Chat using AI',
        hasTabs: false,
        subTabPath: 'CityFALCON-Chat-using-AI',
        videos: [
          {
            id: 80,
            link: 'https://cityfalcon.wistia.com/medias/91pmxfhey7',
          },
        ],
      },
      {
        id: 36,
        title: 'Alexa Providing News on Coronavirus',
        hasTabs: false,
        subTabPath: 'Alexa-Providing-News-on-Coronavirus',
        videos: [
          {
            id: 81,
            link: 'https://cityfalcon.wistia.com/medias/fsozhidt15',
          },
        ],
      },
    ],
  },
];

export default helpCenter;
